/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AccountRouteImport } from './routes/account'
import { Route as AlgorithmsRouteImport } from './routes/algorithms'
import { Route as CreditsRouteImport } from './routes/credits'
import { Route as DevicesRouteImport } from './routes/devices'
import { Route as ExperimentsRouteImport } from './routes/experiments'
import { Route as HelpRouteImport } from './routes/help'
import { Route as MessagesRouteImport } from './routes/messages'
import { Route as SdkRouteImport } from './routes/sdk'
import { Route as TasksRouteImport } from './routes/tasks'
import { Route as DevComponentsRouteImport } from './routes/dev.components'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountRoute = AccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => rootRouteImport,
} as any)
const AlgorithmsRoute = AlgorithmsRouteImport.update({
  id: '/algorithms',
  path: '/algorithms',
  getParentRoute: () => rootRouteImport,
} as any)
const CreditsRoute = CreditsRouteImport.update({
  id: '/credits',
  path: '/credits',
  getParentRoute: () => rootRouteImport,
} as any)
const DevicesRoute = DevicesRouteImport.update({
  id: '/devices',
  path: '/devices',
  getParentRoute: () => rootRouteImport,
} as any)
const ExperimentsRoute = ExperimentsRouteImport.update({
  id: '/experiments',
  path: '/experiments',
  getParentRoute: () => rootRouteImport,
} as any)
const HelpRoute = HelpRouteImport.update({
  id: '/help',
  path: '/help',
  getParentRoute: () => rootRouteImport,
} as any)
const MessagesRoute = MessagesRouteImport.update({
  id: '/messages',
  path: '/messages',
  getParentRoute: () => rootRouteImport,
} as any)
const SdkRoute = SdkRouteImport.update({
  id: '/sdk',
  path: '/sdk',
  getParentRoute: () => rootRouteImport,
} as any)
const TasksRoute = TasksRouteImport.update({
  id: '/tasks',
  path: '/tasks',
  getParentRoute: () => rootRouteImport,
} as any)
const DevComponentsRoute = DevComponentsRouteImport.update({
  id: '/dev/components',
  path: '/dev/components',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/account': typeof AccountRoute
  '/algorithms': typeof AlgorithmsRoute
  '/credits': typeof CreditsRoute
  '/devices': typeof DevicesRoute
  '/experiments': typeof ExperimentsRoute
  '/help': typeof HelpRoute
  '/messages': typeof MessagesRoute
  '/sdk': typeof SdkRoute
  '/tasks': typeof TasksRoute
  '/dev/components': typeof DevComponentsRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/account': typeof AccountRoute
  '/algorithms': typeof AlgorithmsRoute
  '/credits': typeof CreditsRoute
  '/devices': typeof DevicesRoute
  '/experiments': typeof ExperimentsRoute
  '/help': typeof HelpRoute
  '/messages': typeof MessagesRoute
  '/sdk': typeof SdkRoute
  '/tasks': typeof TasksRoute
  '/dev/components': typeof DevComponentsRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/account': typeof AccountRoute
  '/algorithms': typeof AlgorithmsRoute
  '/credits': typeof CreditsRoute
  '/devices': typeof DevicesRoute
  '/experiments': typeof ExperimentsRoute
  '/help': typeof HelpRoute
  '/messages': typeof MessagesRoute
  '/sdk': typeof SdkRoute
  '/tasks': typeof TasksRoute
  '/dev/components': typeof DevComponentsRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/account'
    | '/algorithms'
    | '/credits'
    | '/devices'
    | '/experiments'
    | '/help'
    | '/messages'
    | '/sdk'
    | '/tasks'
    | '/dev/components'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/account'
    | '/algorithms'
    | '/credits'
    | '/devices'
    | '/experiments'
    | '/help'
    | '/messages'
    | '/sdk'
    | '/tasks'
    | '/dev/components'
  id:
    | '__root__'
    | '/'
    | '/account'
    | '/algorithms'
    | '/credits'
    | '/devices'
    | '/experiments'
    | '/help'
    | '/messages'
    | '/sdk'
    | '/tasks'
    | '/dev/components'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AccountRoute: typeof AccountRoute
  AlgorithmsRoute: typeof AlgorithmsRoute
  CreditsRoute: typeof CreditsRoute
  DevicesRoute: typeof DevicesRoute
  ExperimentsRoute: typeof ExperimentsRoute
  HelpRoute: typeof HelpRoute
  MessagesRoute: typeof MessagesRoute
  SdkRoute: typeof SdkRoute
  TasksRoute: typeof TasksRoute
  DevComponentsRoute: typeof DevComponentsRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account': {
      id: '/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AccountRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/algorithms': {
      id: '/algorithms'
      path: '/algorithms'
      fullPath: '/algorithms'
      preLoaderRoute: typeof AlgorithmsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/credits': {
      id: '/credits'
      path: '/credits'
      fullPath: '/credits'
      preLoaderRoute: typeof CreditsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/devices': {
      id: '/devices'
      path: '/devices'
      fullPath: '/devices'
      preLoaderRoute: typeof DevicesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/experiments': {
      id: '/experiments'
      path: '/experiments'
      fullPath: '/experiments'
      preLoaderRoute: typeof ExperimentsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/help': {
      id: '/help'
      path: '/help'
      fullPath: '/help'
      preLoaderRoute: typeof HelpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/messages': {
      id: '/messages'
      path: '/messages'
      fullPath: '/messages'
      preLoaderRoute: typeof MessagesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sdk': {
      id: '/sdk'
      path: '/sdk'
      fullPath: '/sdk'
      preLoaderRoute: typeof SdkRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tasks': {
      id: '/tasks'
      path: '/tasks'
      fullPath: '/tasks'
      preLoaderRoute: typeof TasksRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dev/components': {
      id: '/dev/components'
      path: '/dev/components'
      fullPath: '/dev/components'
      preLoaderRoute: typeof DevComponentsRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AccountRoute: AccountRoute,
  AlgorithmsRoute: AlgorithmsRoute,
  CreditsRoute: CreditsRoute,
  DevicesRoute: DevicesRoute,
  ExperimentsRoute: ExperimentsRoute,
  HelpRoute: HelpRoute,
  MessagesRoute: MessagesRoute,
  SdkRoute: SdkRoute,
  TasksRoute: TasksRoute,
  DevComponentsRoute: DevComponentsRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
